module.exports = __webpack_public_path__ + "img/Logo_Corgio-main-v2-250x250.bfdc3976.png";